<template>
  <v-layout row>
    <v-flex v-bind='size' >
      <v-list>
        <!-- eslint-disable vue/no-use-v-if-with-v-for -->
        <v-list-tile
          v-for="(item, index) in info"
          :key="index"
          v-if="authenticated || item.visibleOnLogin !== false"
        >
        <!-- eslint-enable vue/no-use-v-if-with-v-for -->
          <v-list-tile-content class='oem-quaternary-text-color'>
            {{ item.key }}
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if='authenticated && demo'>
          <v-list-tile-content class='oem-quaternary-text-color'>
            Style
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-flex>
    <v-flex xs7>
      <v-list>
        <v-list-tile>
          <v-list-tile-content>
              Power meter
          </v-list-tile-content>
        </v-list-tile>
         <v-list-tile>
          <v-list-tile-content v-if='authenticated && demo'>
            <v-select
              v-model='storeState.data.deviceInfo.model'
              :items='modelOptions'
              class='pt-1 oem-text-color'
              @change='$store.refreshData()'
            ></v-select>
          </v-list-tile-content>
          <v-list-tile-content v-else>
            {{ `SPM${$store.getDeviceModelNumberText()}EDN` }}
          </v-list-tile-content>
        </v-list-tile>
         <v-list-tile>
          <v-list-tile-content>
              {{ storeState.data.deviceInfo.serial }}
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if='authenticated'>
          <v-list-tile-content>
            <v-select
              v-model='storeState.timezone'
              :items='storeState.timezones'
              item-value='name'
              item-text='name'
              auto
              @change='updateTimezone()'
            >
              <template slot='selection' slot-scope='data'>
                <span style='white-space:nowrap; color:var(--secondary-text-color)'>{{ data.item.name }} ({{ data.item.offsetString }})</span>
              </template>
              <template slot='item' slot-scope='data'>
                <span style='white-space:nowrap'>{{ data.item.name }} ({{ data.item.offsetString }})</span>
              </template>
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            {{ getCurrentTime().toLocaleDateString('en-US') }}
          </v-list-tile-content>
          <v-list-tile-action v-if='authenticated'>
            <v-btn icon>
              <v-icon @click='datePicker = true' class='pt-2 oem-text-color'>
                date_range
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            {{ storeState.timezones.length === 0 ? '' : getCurrentTime().toLocaleTimeString('en-US') }}
          </v-list-tile-content>
           <v-list-tile-action v-if='authenticated'>
            <v-btn icon>
              <v-icon @click='timePicker = true' class='pt-2 oem-text-color'>
                access_time
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile v-if='authenticated && demo'>
           <v-select
              v-model='storeState.style'
              :items='styleOptions'
              class='pt-2 oem-text-color'
            ></v-select>
        </v-list-tile>
      </v-list>
    </v-flex>
    <v-dialog v-model='datePicker' full-width width="290px">
      <v-date-picker
        v-model='currentDate'
        scrollable
        @input='datePicker = false'
      >
      </v-date-picker>
    </v-dialog>
    <v-dialog v-model='timePicker' full-width width="290px">
      <v-time-picker
        v-model='currentTime'
        scrollable
      >
      </v-time-picker>
    </v-dialog>
  </v-layout>
</template>

<script>

export default {
  name: 'DeviceInfo',
  props: {
    authenticated: Boolean,
    demo: Boolean,
  },
  data() {
    return {
      storeState: this.$store.state,
      basetime: 0,
      now: new Date(),
      info: [
        { key: 'Product' },
        { key: 'Model' },
        { key: 'Serial no.' },
        { key: 'Timezone', visibleOnLogin: false },
        { key: 'Date' },
        { key: 'Time' },
      ],
      model: 0,
      serial: 0,
      datePicker: false,
      timePicker: false,
      modelOptions: [
        { text: 'SPM03EDN', value: 3 },
        { text: 'SPM12EDN', value: 12 },
        { text: 'SPM48EDN', value: 48 },
      ],
      styleOptions: [
        { text: 'Setra', value: 'setra' },
        { text: 'Fluke', value: 'fluke' },
        { text: 'Siemens', value: 'siemens' },
      ],
    };
  },
  computed: {
    currentDate: {
      // eslint-disable-next-line
      get: function() {
        return this.storeState.now.toISOString().substr(0, 10);
      },
      // eslint-disable-next-line
      set: function(newDate) {
        const parts = newDate.split('-');
        const dateTimeBefore = this.getCurrentTime();
        const dateTimeAfter = new Date(dateTimeBefore.getTime());
        dateTimeAfter.setFullYear(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        dateTimeAfter.setHours(dateTimeBefore.getHours(), dateTimeBefore.getMinutes());

        const differenceInSeconds = (dateTimeAfter - dateTimeBefore) / 1000;
        this.storeState.now.setSeconds(this.storeState.now.getSeconds() + differenceInSeconds);

        this.storeState.basetime = this.storeState.now.getTime();
        this.storeState.timeUpdated = true;
      },
    },
    currentTime: {
      // eslint-disable-next-line
      get: function() {
        const dateTime = this.getCurrentTime();
        return `${(`0${dateTime.getHours()}`).slice(-2)}:${(`0${dateTime.getMinutes()}`).slice(-2)}`;
      },
      // eslint-disable-next-line
      set: function(newDate) {
        const parts = newDate.split(':');
        const dateTimeBefore = this.getCurrentTime();
        const dateTimeAfter = new Date(dateTimeBefore.getTime());
        dateTimeAfter.setHours(Number(parts[0]), Number(parts[1]));
        dateTimeAfter.setFullYear(dateTimeBefore.getFullYear(), dateTimeBefore.getMonth(), dateTimeBefore.getDate());
        const differenceInSeconds = (dateTimeAfter - dateTimeBefore) / 1000;
        this.storeState.now.setSeconds(this.storeState.now.getSeconds() + differenceInSeconds);
        this.storeState.basetime = this.storeState.now.getTime();
        this.storeState.timeUpdated = true;
      },
    },

    size() {
      const size = {};
      size.xs5 = true;
      if (!this.authenticated) {
        size['offset-xs1'] = true;
      }
      return size;
    },
  },
  methods: {
    updateTimezone() {
      this.storeState.timeUpdated = true;
      this.$store.timezoneUpdated();
    },
    getCurrentTimeUtc() {
      let dateTime = new Date(this.storeState.now.getTime()); // Get date time (but in browser's timezone)
      dateTime = new Date(dateTime.getTime() + (dateTime.getTimezoneOffset() * 60000)); // get date time in UTC
      return dateTime;
    },
    getCurrentTime() {
      let dateTime = this.getCurrentTimeUtc();
      if (this.storeState.timezoneIndex !== -1 && this.storeState.timezones.length !== 0) { // Change date time to configured timezone
        dateTime = new Date(dateTime.getTime() + (this.storeState.timezones[this.storeState.timezoneIndex].offsetInt * 1000));
      }
      return dateTime;
    },
  },
  beforeMount() {
    this.$store.getStaticDeviceInfo();
  },
};
</script>
